var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoConfirmSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20ZM30.0758 12.4242C29.3436 11.6919 28.1564 11.6919 27.4242 12.4242C27.4065 12.4419 27.3899 12.4606 27.3744 12.4803L18.6935 23.5419L13.4597 18.3081C12.7275 17.5758 11.5403 17.5758 10.808 18.3081C10.0758 19.0403 10.0758 20.2275 10.808 20.9597L17.4242 27.5758C18.1564 28.3081 19.3436 28.3081 20.0758 27.5758C20.0921 27.5595 20.1075 27.5423 20.1219 27.5243L30.1024 15.0487C30.8079 14.3145 30.7991 13.1474 30.0758 12.4242Z",
    fill: "#008055"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoConfirmSolid);
export default __webpack_public_path__ + "static/media/ico-confirm_solid.6097158a84182f9ad6ac53855615ef67.svg";
export { ForwardRef as ReactComponent };